import Vue from 'vue'
import cookieUniversal from 'cookie-universal'

import { extractI18nMessages } from "/drone/src/src/app/modules/sh-cookie-consent/utils.js"
import CookieConsent from "/drone/src/src/app/modules/sh-cookie-consent/components/CookieConsent.vue"

export default ({ req, res, store }, inject) => {
  const options = {"alias":"cookies","parseJSON":true,"component":"\u002Fdrone\u002Fsrc\u002Fsrc\u002Fapp\u002Fmodules\u002Fsh-cookie-consent\u002Fcomponents\u002FCookieConsent.vue","utils":"\u002Fdrone\u002Fsrc\u002Fsrc\u002Fapp\u002Fmodules\u002Fsh-cookie-consent\u002Futils.js","i18n":{"storeAlias":"i18n","prefix":"COOKIE_CONSENT"},"whitelist":["i18n_redirected"],"text":{"title":"Cookie Policy","description":"We'd like to use cookies to understand your use of our website and to give you a better experience. To find out more about cookies and how to change your choices, please to go our","link":"Cookie Policy","accept":"Accept","reject":"Reject"},"path":"\u002Fterms-and-policies\u002Fcookie-policy"}
  const cookies = cookieUniversal(req, res, options.parseJSON)
  const { prefix, storeAlias } = options.i18n

  const whitelist = [...options.whitelist, 'cookie_consent']

  // Extend cookies functionality to remove the setter from document
  cookies.expireCookies = () => cookies.setAll(
    Object.entries(cookies
      .getAll())
      .map(([name, value]) => ({
        name,
        value,
        opts: { path: '/', ...(whitelist.includes(name) ? {} : { maxAge: -1 }) }
      })
    )
  )

  inject(options.alias, cookies)

  const currentConsent = cookies.get('cookie_consent')

  if (currentConsent === false) {
    // Remove all cookies except cookie_consent
    cookies.expireCookies()
  }

  store.registerModule('cookie_consent', {
    namespaced: true,
    state () {
      return {
        i18n: options.i18n,
        text: options.text,
        path: options.path,
        consent: null
      }
    },
    getters: {
      localizedText ({ text }, _, rootState) {
        const messages = rootState[storeAlias].messages
        return { ...text, ...extractI18nMessages(messages, prefix) }
      }
    },
    actions: {
      setCookieConsent ({ commit }, consent) {
        commit('SET_CONSENT', consent)
      }
    },
    mutations: {
      SET_CONSENT (state, consent) {
        state.consent = consent
      }
    }
  })

  Vue.component('CookieConsent', CookieConsent)
}
